













import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */

import CalendarDayListItem from "./CalendarDayListItem.vue";
import { Guid } from "@/domain/guid";
import { SignupState } from "@/api/compositions/signup-state";
import { GetCompositionGroupsResponse } from "@/api/compositions/get-composition-groups.response";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */

/**
 * Calendar cell day list.
 */
@Component({
	components: {CalendarDayListItem}
})
export default class CalendarDayList extends Vue {
	/// Properties
	@Prop()
	compositionGroups!: GetCompositionGroupsResponse.CompositionGroup[];

	@Prop()
	onContextMenu!: (id: Guid, ev: PointerEvent) => void;

	@Prop()
	onSignup!: (compositionGroupID: Guid, newSignupState: SignupState) => Promise<void>;

	@Prop({
		default: false,
		type: Boolean
	})
	isEditMode!: boolean;
}
